// extracted by mini-css-extract-plugin
module.exports = {"root":"NoLookBoardsModal_root__39ost","title":"NoLookBoardsModal_title__3YB5Q","border":"NoLookBoardsModal_border__2gi46"};